import { render, staticRenderFns } from "./Attorneys.vue?vue&type=template&id=51a20f2d&scoped=true&"
import script from "./Attorneys.vue?vue&type=script&lang=js&"
export * from "./Attorneys.vue?vue&type=script&lang=js&"
import style0 from "./Attorneys.vue?vue&type=style&index=0&id=51a20f2d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a20f2d",
  null
  
)

export default component.exports